export const SET_PROJECT = 'SET_PROJECT';
